import * as React from 'react';
import Flex, { Props as FlexProps } from '../Flex/Flex';

export interface Props extends FlexProps {}

/**
 * Dividers that can be used to separate CardContents. Can be used
 * horizontally or vertically, just use the direction prop on the Card
 * component.
 */
const CardDivider: React.FunctionComponent<Props> = (props: Props) => {
  return (
    <Flex { ...props } className="Card__divider" />
  );
};

export default CardDivider;
